module.exports = __webpack_public_path__ + "img/icon_option_set_4.cac21655.svg";